<template>
  <v-container class="d-flex align-center" fluid style="height: auto">
    <v-row>
      <!-- Profile Basics !-->
      <v-col cols="4">
        <v-card class="pa-5" outlined style="background-color: rgba(0,0,0,0)">
          <v-container fluid>
            <v-row align="center" justify="center">
              <image-input v-model="avatar">
                <div slot="activator">
                  <v-avatar class="avatar-profile ml-1 justify-center" size="105">
                    <v-img :src="avatar.imageURL"></v-img>
                  </v-avatar>
                </div>
              </image-input>
              <v-slide-x-transition>
                <div v-if="avatar && saved == false" class="ml-2">
                  <v-btn
                      :loading="saving"
                      class="primary"
                      fab
                      light
                      small
                      @click="uploadImage">
                    <v-icon color="white">fa-check</v-icon>
                  </v-btn>
                  <v-btn
                      class="ml-2 red"
                      fab
                      light
                      small
                      @click="cancelUploadImage">
                    <v-icon color="white">fa-times</v-icon>
                  </v-btn>
                </div>
              </v-slide-x-transition>
            </v-row>
            <v-row v-if="this.$store.state.user.isPro" class="mt-n3" align="center" justify="center">
              <ProBadge size="medium"/>
            </v-row>
            <v-row>
              <v-col>
                <h2 class="text-center">{{ this.$store.state.user.firstName }} {{
                    this.$store.state.user.lastName
                  }}</h2>
                <h3 class="text-center">
                  {{ $t('mainCard.countryPrepend') }}
                  {{ $store.state.user.details.country }}
                  <Flag :code="userCountry" size="S"/>
                </h3>
                <p class="text-center mt-2">{{ this.$store.state.user.details.profileDescription }}</p>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-chip small @click="editProfile">
                {{ $t('mainCard.btnEditProfile') }}
                <v-icon class="icon ml-2" x-small>fa-pen</v-icon>
              </v-chip>
            </v-row>
            <v-divider class="my-7"/>
            <v-row align="center" justify="center">
              <p class="mb-1">
                <b>Username:</b> {{ this.$store.state.user.username }}<br>
                <b>Automation Token:</b> {{ this.$store.state.user.details.automationToken }}
                <v-chip class="ml-2 mt-n1" small @click="changeToken">{{ $t('mainCard.btnChangeToken') }}
                  <v-icon class="icon ml-2" x-small>fa-sync-alt</v-icon>
                </v-chip>
              </p>
            </v-row>
            <v-divider class="my-7"/>
            <v-row align="center" class="mb-n3" justify="center">
              <v-icon class="mt-n5">fa-language</v-icon>
              <p class="mt-n5 mb-0 mx-3">{{ $t('mainCard.languagePrepend') }}</p>
              <v-select v-model="selectedLanguage" :items="languages" dense item-text="text"
                        item-value="lang" outlined style="max-width: 35%" @change="changeLanguage"/>
            </v-row>
          </v-container>
        </v-card>
      </v-col>

      <!-- Sharing Properties, Telegram and Broker Accounts !-->
      <v-col cols="8">
        <v-container fluid>
          <v-row>
            <!--v-col cols="6">
              <h3>Sharing Properties <i class="ml-2" style="font: 14px 'Ubuntu'; color: #0f7500">( SOON )</i></h3>
              <div class="d-flex align-center">
                <p class="mt-3">Currently your journal visibility is: <b>{{ capitalize(this.$store.state.user.details.profileStatus) }}</b></p>
                <v-chip class="mt-n1 ml-3" @click="editVisibility" small>Edit visibility<v-icon class="icon ml-2" x-small>fa-eye</v-icon></v-chip>
              </div>
            </v-col-->
            <v-col cols="7">
              <h3>{{ $t('telegramModule.title') }}</h3>
              <p v-if="!this.$store.state.user.isPro" class="mt-3">{{ $t('telegramModule.callToAction') }}
                <v-chip class="mt-n1 ml-3" color="accent" small text-color="black" @click="goToProPlans">
                  {{ $t('telegramModule.btnCallToAction') }}
                  <v-icon class="icon ml-2" color="black" x-small>fa-star</v-icon>
                </v-chip>
              </p>
              <TelegramSignin v-else-if="(this.$store.state.user.details.telegramId == null || this.$store.state.user.details.telegramId === '')"
                              class="mt-2"/>
              <p v-else class="mt-3">
                <v-chip color="light-blue darken-4" outlined small text-color="light-blue darken-4">
                  {{ $t('telegramModule.btnAlreadyAssociated') }}
                  <v-icon class="icon ml-2" color="light-blue darken-4" x-small>fa-check</v-icon>
                </v-chip>
                <v-chip class="ml-3" small @click="unpairTelegram">{{ $t('telegramModule.btnUnpair') }}
                  <v-icon class="ml-2" x-small>fa-unlink</v-icon>
                </v-chip>
              </p>
            </v-col>
            <v-col v-if="this.$store.state.user.isPro" cols="5">
              <p class="mt-9 mb-0 text-end" style="color: #777777">
                <a @click="cancelSubscription">Click here</a> to deactivate you subscription.</p>
            </v-col>
          </v-row>

          <v-divider class="mb-4 mt-2"/>

          <h3>{{ $t('platformModule.title') }}</h3>
          <LinkedPlatforms/>

          <v-divider class="mb-4 mt-2"/>

          <!--Broker Accounts!-->
          <v-row>
            <v-col cols="12">
              <div class="d-flex align-center"><h3>{{ $t('brokerModule.title') }} {{
                  this.$store.state.user.firstName
                }}</h3>
                <v-btn class="ml-5" @click="addBrokerAccount">{{ $t('brokerModule.btnAdd') }}</v-btn>
              </div>
              <br>
              <br>
              <v-data-table :headers="brokerAccountsTableHeaders" :items="this.$store.state.user.brokerAccounts"
                            style="background-color: rgba(0,0,0,0)">
                <template v-slot:item.broker.name="{ item }">
                  <p class="my-0" style="font-size: 14px">
                    {{ item.broker.name }}
                    <v-chip v-if="brokersWithMT4IntegrationIds.findIndex(value => value === item.broker.id) !== -1" class="ml-2" small
                            @click="linkMetaTrader(item)">
                      <span style="font-size: 14px;">{{ $t('brokerModule.linkMetaTraderBtn') }}</span>
                      <v-icon class="icon ml-2" color="black" x-small>fa-laptop</v-icon>
                    </v-chip>
                  </p>
                </template>
                <template v-slot:item.type="{ item }">
                  <p class="my-0" style="font-size: 14px">{{ `${item.type} (${item.currency})` }}</p>
                </template>
                <template v-slot:item.automated="{ item }">
                  <v-icon v-if="item.automated" color="green" small>fa-check-circle</v-icon>
                  <p v-else class="my-0" style="font-size: 14px">{{ $t('none') }}</p>
                </template>
                <template v-slot:item.verified="{ item }">
                  <v-icon v-if="item.verified" color="blue" small>fa-check-circle</v-icon>
                  <v-chip v-else-if="item.automated" small @click="verifyBrokerAccount(item)">
                    <span style="font-size: 14px;">{{ $t('brokerModule.tableVerifyNow') }}</span>
                    <v-icon class="icon ml-2" color="black" x-small>fa-check-circle</v-icon>
                  </v-chip>
                  <p v-else class="my-0" style="font-size: 14px">{{ $t('none') }}</p>
                </template>
                <template v-slot:item.action="{ item }">
                  <v-icon class="mr-3 icon" small @click="editBroker(item)">fa-pen</v-icon>
                  <v-icon v-if="!item.verified" class="icon" small @click="deleteBroker(item)">fa-trash</v-icon>
                </template>
              </v-data-table>
            </v-col>
          </v-row>

        </v-container>
      </v-col>
    </v-row>

    <!-- Overlay for Edit Profile!-->
    <v-overlay v-model="overlayEditProfile">
      <EditProfile @closeWindow="closeOverlayEditProfile"/>
    </v-overlay>

    <!-- Overlay for Edit Visibility!-->
    <v-overlay v-model="overlayEditVisibility">
      <EditVisibility @closeWindow="closeOverlayEditVisibility"/>
    </v-overlay>

    <!-- Overlay for Edit Broker Account!-->
    <v-overlay v-model="dialogEditBrokerAccount">
      <EditBrokerAccount :brokerAccount="currentBroker" @closeWindow="closeDialogEditBrokerAccount"/>
    </v-overlay>

    <!-- Overlay for Delete Broker Account!-->
    <v-overlay v-model="dialogDeleteBrokerAccount">
      <DeleteBrokerAccount :brokerAccount="currentBroker" @closeWindow="closeDialogDeleteBrokerAccount"/>
    </v-overlay>

    <!-- Overlay for Add Broker Account!-->
    <v-overlay v-model="dialogAddBrokerAccount">
      <AddBrokerAccount @closeWindow="closeDialogAddBrokerAccount"/>
    </v-overlay>

    <!-- Overlay for Upgrade to Pro !-->
    <v-overlay v-model="dialogUpgradeToPro">
      <UpgradeToPro :message="messageUpgradeToPro" @closeWindow="closeDialogUpgradeToPro"/>
    </v-overlay>

    <!-- Overlay for link MetaTrader !-->
    <v-overlay v-model="overlayLinkMetaTrader">
      <LinkMetaTrader :broker-account="currentBroker" @closeWindow="overlayLinkMetaTrader = false"/>
    </v-overlay>

    <!-- Overlay for verify broker account !-->
    <v-overlay v-model="dialogVerifyBrokerAccount">
      <VerifyBrokerAccount :broker-account="currentBroker" @closeWindow="dialogVerifyBrokerAccount = false"/>
    </v-overlay>

    <!-- Overlay for change automation token !-->
    <v-overlay v-model="overlayChangeToken">
      <ChangeToken @closeWindow="overlayChangeToken = false"/>
    </v-overlay>

    <!-- Overlay for unpair Telegram !-->
    <v-overlay v-model="overlayUnpairTelegram">
      <UnpairTelegram @closeWindow="overlayUnpairTelegram = false"/>
    </v-overlay>

    <!-- Overlay to unsubscribe !-->
    <v-overlay v-model="overlayCancelSubscription">
      <CancelSubscription @closeWindow="overlayCancelSubscription = false"/>
    </v-overlay>

    <!-- Overlay to add referred !-->
    <v-overlay v-model="overlayAddReferredFrom">
      <EditReferredFrom :referred="referred" @closeWindow="overlayAddReferredFrom = false"/>
    </v-overlay>

    <!-- Overlay to show referred error (invalid referred) !-->
    <v-overlay v-model="overlayReferredError">
      <ReferredError :referred="referred" @closeWindow="overlayReferredError = false"/>
    </v-overlay>
  </v-container>
</template>

<script>
//Repositories
import BrokerAccountRepository from '../../repositories/brokerAccount';
import SubscriptionRepository from '../../repositories/subscription';
import AuthRepository from '../../repositories/auth';

import EditBrokerAccount from "./views/EditBrokerAccount";
import AddBrokerAccount from "./views/AddBrokerAccount";
import DeleteBrokerAccount from "./views/DeleteBrokerAccount";
import ProLimits from '../../proLimits';
import UpgradeToPro from "../../components/UpgradeToPro";
import EditProfile from "./views/EditProfile";
import EditVisibility from "./views/EditVisibility";
import TelegramSignin from "../../components/TelegramSignin";
import VerifyBrokerAccount from "@/views/User/views/VerifyBrokerAccount";

import {mapMutations} from 'vuex';
import ChangeToken from "@/views/User/views/ChangeToken";
import UnpairTelegram from "@/views/User/views/UnpairTelegram";
import CancelSubscription from "@/views/User/views/CancelSubscription";
import EditReferredFrom from "@/views/User/views/EditReferredFrom";
import ReferredError from "@/views/User/views/ReferredError";
import ImageInput from '../../components/ImageInput.vue'
import LinkMetaTrader from "@/views/User/views/LinkMetaTrader";
import LinkedPlatforms from "@/views/User/views/LinkedPlatforms";
import CountriesData from '../Register/countries';
import ProBadge from "@/components/ProBadge.vue";

export default {
  props: {
    referred: String,
  },
  name: "Profile",
  components: {
    ProBadge,
    LinkedPlatforms,
    LinkMetaTrader,
    UnpairTelegram,
    ChangeToken,
    VerifyBrokerAccount,
    TelegramSignin,
    EditVisibility,
    EditProfile,
    UpgradeToPro,
    DeleteBrokerAccount,
    AddBrokerAccount,
    EditBrokerAccount,
    CancelSubscription,
    EditReferredFrom,
    ReferredError,
    ImageInput
  },
  data() {
    return {
      selectedLanguage: 'en',
      countries: CountriesData,
      languages: [
        {text: 'English 🇬🇧', lang: 'en'},
        {text: 'Español 🇪🇸', lang: 'es'},
      ],
      brokersWithMT4IntegrationIds: [316, 308], // Should be obtained from db

      currentBroker: null,
      overlayEditProfile: false,
      overlayEditVisibility: false,
      dialogEditBrokerAccount: false,
      dialogDeleteBrokerAccount: false,
      dialogAddBrokerAccount: false,
      dialogVerifyBrokerAccount: false,
      overlayChangeToken: false,
      overlayUnpairTelegram: false,
      overlayCancelSubscription: false,
      overlayLinkMetaTrader: false,
      overlayAddReferredFrom: false,
      overlayReferredError: false,
      brokerAccountsTableHeaders: [],

      //avatar uploading
      avatar: {},
      saving: false,
      saved: true,

      // Upgrade to pro
      messageUpgradeToPro: 'With pro you can have unlimited broker accounts associated.',
      dialogUpgradeToPro: false,
    };
  },
  computed: {
    userCountry() {
      let countryFound = this.countries.find((country) => country.name === this.$store.state.user.details.country );
      return (countryFound !== undefined)? countryFound.code : '';
    }
  },
  mounted() {
    this.validateAuthenticated();
    this.init();
    this.getTable();
  },
  watch: {
    '$i18n.locale': function () {
      this.getTable();
    },
    avatar: {
      handler: function () {
        if (this.avatar.formData) {
          this.saved = false
        }
      },
      deep: true
    }
  },
  methods: {
    cancelUploadImage() {
      this.avatar.imageURL = this.$store.state.user.imageUrl;
      setTimeout(() => this.savedAvatar(), 100)
    },
    uploadImage() {
      this.saving = true
      AuthRepository.updateUserAvatar(this.avatar.formData).then((response) => {
        this.$store.state.user.imageUrl = response.data;
        this.avatar.imageURL = response.data;
        setTimeout(() => this.savedAvatar(), 1000)
      });
    },
    savedAvatar() {
      this.saving = false
      this.saved = true
    },
    getTable() {
      this.brokerAccountsTableHeaders = [
        {text: this.$t('brokerModule.tableBrokerName'), value: 'broker.name'},
        {text: this.$t('brokerModule.tableAccountId'), value: 'identifier'},
        {text: this.$t('brokerModule.tableAccountType'), value: 'type'},
        {text: this.$t('brokerModule.tableAutomated'), value: 'automated', sortable: false},
        {text: this.$t('brokerModule.tableVerified'), value: 'verified', sortable: false},
        {text: this.$t('brokerModule.tableActions'), value: 'action', sortable: false},
      ];
    },
    validateAuthenticated() {
      if (this.$store.state.token === '')
        this.$router.push('/');
    },
    ...mapMutations(['setBrokerAccounts']),
    init() {
      BrokerAccountRepository.allBrokerAccountsOfUser().then((response) => { this.setBrokerAccounts(response.data); });
      if (this.referred && this.$store.state.user.details.referredFrom == null) {
        SubscriptionRepository.getPlansByCoupon(this.referred).catch((error) => {
          if (error.response.status === 401) {
            this.$store.commit('clearData');
            this.$router.push('/');
          } else if (error.response.status === 400)
            this.overlayReferredError = true;
        }).then((response) => {
          if (response.status === 200)
            this.overlayAddReferredFrom = true;
        });
      }
      this.selectedLanguage = this.$store.state.preferredLanguage;
      this.avatar.imageURL = this.$store.state.user.imageUrl;
    },
    changeLanguage() {
      if (this.$i18n.locale === "en") {
        this.$root.$i18n.locale = "es";
        this.saveLanguage("es", "en");
      } else {
        this.$root.$i18n.locale = "en";
        this.saveLanguage("en", "es");
      }
    },
    ...mapMutations(['setPreferredLanguage']),
    saveLanguage(newLang, previousLang) {
      let languageData = {
        newLang: newLang,
        previousLang: previousLang,
      };

      AuthRepository.editLanguage(languageData).then((response) => {
        if (response.status < 400) {
          alert(this.$t('alert.languageChange'));
          this.setPreferredLanguage(newLang);
        }
      });
    },
    changeToken() {
      this.overlayChangeToken = true;
    },
    editProfile() {
      this.overlayEditProfile = true;
    },
    editVisibility() {
      this.overlayEditVisibility = true;
    },
    unpairTelegram() {
      this.overlayUnpairTelegram = true;
    },
    cancelSubscription() {
      this.overlayCancelSubscription = true;
    },
    editBroker(brokerAccount) {
      this.currentBroker = brokerAccount;
      this.dialogEditBrokerAccount = true;
    },
    deleteBroker(brokerAccount) {
      this.currentBroker = brokerAccount;
      this.dialogDeleteBrokerAccount = true;
    },
    addBrokerAccount() {
      if (this.$store.state.user.isPro || ProLimits.verifyLimitsByBrokerAccounts(this.$store.state.user.brokerAccounts.length))
        this.dialogAddBrokerAccount = true;
      else {
        this.messageUpgradeToPro = 'With pro you can have unlimited broker accounts associated.';
        this.dialogUpgradeToPro = true;
      }
    },
    linkMetaTrader(brokerAccount) {
      this.currentBroker = brokerAccount;
      this.overlayLinkMetaTrader = true;
    },
    verifyBrokerAccount(brokerAccount) {
      this.currentBroker = brokerAccount;
      this.dialogVerifyBrokerAccount = true;
    },
    goToProPlans() {
      this.messageUpgradeToPro = 'Get insights of your trading activity and Swiset notifications directly to Telegram.'
      this.dialogUpgradeToPro = true;
    },
    closeOverlayEditProfile() {
      this.overlayEditProfile = false;
    },
    closeOverlayEditVisibility() {
      this.overlayEditVisibility = false;
    },
    closeDialogEditBrokerAccount() {
      this.dialogEditBrokerAccount = false;
    },
    closeDialogDeleteBrokerAccount() {
      this.dialogDeleteBrokerAccount = false;
    },
    closeDialogAddBrokerAccount() {
      this.dialogAddBrokerAccount = false;
    },
    closeDialogUpgradeToPro() {
      this.dialogUpgradeToPro = false;
    },
    capitalize(string) {
      return string[0] + string.slice(1).toLowerCase();
    },
  }
}
</script>

<i18n>
{
  "en": {
    "none": "No",
    "mainCard": {
      "countryPrepend": "From",
      "btnEditProfile": "Edit profile",
      "btnChangeToken": "Change",
      "languagePrepend": "Swiset speaks to me in"
    },
    "telegramModule": {
      "title": "Connect Telegram",
      "btnAlreadyAssociated": "Telegram already associated",
      "callToAction": "Get insights directly to Telegram",
      "btnCallToAction": "Pro Feature",
      "btnUnpair": "Unpair"
    },
    "platformModule": {
      "title": "Connected Platforms"
    },
    "brokerModule": {
      "title": "Broker Account(s) of",
      "btnAdd": "Add Broker Account",
      "tableBrokerName": "Broker Name",
      "tableAccountId": "Account ID",
      "tableAccountType": "Account Type",
      "tableCurrency": "Currency",
      "tableAutomated": "Automated",
      "tableVerified": "Verified",
      "tableActions": "Actions",
      "tableVerifyNow": "Verify Now",
      "linkMetaTraderBtn": "Linked MT4"
    },
    "alert": {
      "languageChange": "Swiset will speak to you in english! 🇬🇧"
    }
  },
  "es": {
    "none": "No",
    "mainCard": {
      "countryPrepend": "De",
      "btnEditProfile": "Editar perfil",
      "btnChangeToken": "Cambiar",
      "languagePrepend": "Swiset me habla en"
    },
    "telegramModule": {
      "title": "Conectar Telegram",
      "btnAlreadyAssociated": "Telegram se encuentra asociado",
      "callToAction": "Obtén insights directamente a Telegram",
      "btnCallToAction": "Funcionalidad Pro",
      "btnUnpair": "Desvincular"
    },
    "platformModule": {
      "title": "Plataformas Conectadas"
    },
    "brokerModule": {
      "title": "Cuenta(s) de Broker de",
      "btnAdd": "Añadir Cuenta de Broker",
      "tableBrokerName": "Nombre Broker",
      "tableAccountId": "ID de Cuenta",
      "tableAccountType": "Tipo de Cuenta",
      "tableCurrency": "Moneda",
      "tableAutomated": "Automatizado",
      "tableVerified": "Verificado",
      "tableActions": "Acciones",
      "tableVerifyNow": "Verificar",
      "linkMetaTraderBtn": "MT4 Vinculado"
    },
    "alert": {
      "languageChange": "¡Swiset te hablará en español! 🇪🇸"
    }
  }
}
</i18n>

<style scoped>
.avatar-profile {
  border: 5px solid #c9c9c9 !important;
  border-radius: 500px !important;
  cursor: pointer !important;
}
</style>
